import React from "react";
import format from "date-fns/format/index";
import de from "date-fns/locale/de";
import { utcToZonedTime } from "date-fns-tz";
import Layout from "../components/layout";
import SEO from "../components/seo";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
var EventPage = function EventPage(_ref) {
    var data = _ref.data, location = _ref.location;
    var event = data.allDatoCmsEvent.edges[0].node;
    var utcDate = new Date(event.time).toISOString();
    var zonedDate = utcToZonedTime(utcDate, "Europe/Berlin");
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: event.title
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "pb-10 lg:w-2/3"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "Veranstaltung"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 lg:px-8"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl pt-2 md:text-5xl"
    }, event.title), /*#__PURE__*/ React.createElement("div", {
        className: "my-6 content-text"
    }, format(zonedDate, "dd. MMMM yyyy,  HH:mm", {
        locale: de
    }), " Uhr", event.locationName && " | " + event.locationName), /*#__PURE__*/ React.createElement("div", {
        className: "content-text",
        dangerouslySetInnerHTML: {
            __html: event.description
        }
    })))));
};
var query = "1172341949";
export default EventPage;
